

























































import {Component, Vue} from 'vue-property-decorator'
import html2canvas from 'html2canvas'
const BG = require('../assets/bg@3x.png')

@Component({
    components: {},
})
export default class ChoiceBedRoom extends Vue {
    private name: string = localStorage.getItem('name') || '独孤不睡'
    private personImg: string = require('../assets/img_polaroid_sleepboy@3x.png')
    private c: any = null
    private quilt: string = ''
    private ghosts: any = []
    private time: string = ''
    private date: string = ''
    private beforeDestroy () {
        clearInterval(this.c)
    }
    private toDrawing () {
        document.querySelector('.ghost-template')
        return new Promise((resolve) => {
            const dom = document.querySelector('#canvas')
            // const container = document.querySelector('.outer-img')
            html2canvas(dom as HTMLElement, {
                useCORS: true,
                onclone: (document) => {
                    // const attr = document.querySelector('#canvas') as HTMLElement
                    // // attr.style.background = `url("${BG}")`
                    // // attr.style.backgroundSize = '180px 180px'
                    // this.setDomStyle(document, ['.bottom-hidden-template', '.title'])

                    // const attr2 = document.querySelector('.title-2') as HTMLElement
                    // attr.style['clip-path'] = 'unset'
                    // this.setDomStyle(document, '.ghost-template')
                    // this.setDomStyle(document, '.img-bg')
                    // const attr = document.querySelector('.bottom-hidden-template') as HTMLElement
                    // attr.style.opacity = '1'
                    // const attr2 = document.querySelector('.ghost-template') as HTMLElement
                }
            }).then((canvas) => {
                const img = new Image()
                img.src = canvas.toDataURL()
                img.style.width = '100%'
                img.style.position = 'absolute'
                img.style.left = '50%'
                img.style.top = '50%'
                img.style.transform = 'translateX(-50%) translateY(-50%)'
                this.$root.imgSaver = img.src
                resolve()
            })
        })
    }
    private setDomStyle (document: any, name: string[]) {
        for (const i of name) {
            const attr = document.querySelector(i) as HTMLElement
            attr.style.opacity = '1'
            attr.classList.remove('animated')
            attr.classList.remove('fadeIn')
        }
    }
    private mounted () {
        if (!this.$root.ghostBed.ghosts) {
            this.$router.replace('./')
            return
        }

        this.name = this.$root.ghostBed.name
        this.quilt = this.$root.ghostBed.quilt
        this.ghosts = this.$root.ghostBed.ghosts
        this.personImg = this.$root.ghostBed.personImg

        this.date = this.$wjh.dateFormat((new Date()).valueOf(), 'yyyy/MM/dd')
        this.c = setInterval(() => {
            this.time = this.$wjh.dateFormat((new Date()).valueOf(), 'hh:mm')
        }, 1000)
    }
}
